
import React, { useEffect } from 'react';
import ContentDetailPanel from './ContentDetailPanel';
import ContentRelatedItems from './ContentRelatedItems';
import { useContentOperations } from '@/hooks/useContentOperations';
import { ScrollArea } from '@/components/ui/scroll-area';
import { ViewMode } from "@/hooks/usePersistentViewMode";

interface ContentContainerProps {
  contentItem: any;
  contentId: string;
  viewMode: ViewMode;
  onRelatedContentClick: (id: string) => void;
  refetch: () => Promise<any>;
}

const ContentContainer: React.FC<ContentContainerProps> = ({ 
  contentItem, 
  contentId, 
  viewMode, 
  onRelatedContentClick,
  refetch
}) => {
  const { handleDelete, handleArchive } = useContentOperations();
  
  // Update document title
  useEffect(() => {
    if (contentItem) {
      document.title = `${contentItem.title} - Clustr`;
    }
  }, [contentItem]);
  
  // Get the collection color from the content item or use default
  const collectionColor = contentItem?.collection_color || "#6B7789";
  
  // Debug log to help trace the collection color
  console.log("[COLOR DEBUG] ContentContainer received contentItem:", {
    id: contentItem?.id,
    title: contentItem?.title,
    collection_color: contentItem?.collection_color,
    collection_id: contentItem?.collection_id,
    usingColor: collectionColor
  });

  return (
    <ScrollArea className="flex-1">
      <div className="px-7 pt-4 pb-10">
        {/* Content detail panel */}
        <div className="mb-6">
          <ContentDetailPanel contentItem={contentItem} onUpdate={refetch} />
        </div>

        {/* Related content items */}
        <div>
          <ContentRelatedItems 
            collectionId={contentItem.collection_id} 
            currentContentId={contentId} 
            viewMode={viewMode}
            onContentClick={onRelatedContentClick}
            onDeleteContent={handleDelete}
            onArchiveContent={handleArchive}
            collectionColor={collectionColor} // Explicitly pass the collection color
          />
        </div>
      </div>
    </ScrollArea>
  );
};

export default ContentContainer;
